import { isPast } from 'core/utils/date'

import { type SpotQuoteListRate } from './SpotQuoteListRate'

export type SpotQuoteListLanes = {
  total: number
  pending: number
  submitted: number
  expired: number
  soonestBidDeadline?: Date
  rates: Array<SpotQuoteListRate>
  uuid?: string
}

export function isSoonestBidDeadlineExpired({ soonestBidDeadline }: SpotQuoteListLanes) {
  if (!soonestBidDeadline) return true

  return isPast(soonestBidDeadline)
}
